import React, {useEffect, useState} from 'react';
import {VideoPlayer} from "../components/video-player/video-player";
import Grid from "@material-ui/core/Grid";
import {makeStyles} from "@material-ui/core/styles";
import {NavLink} from "react-router-dom";

const iOS = process.browser && /iPad|iPhone|iPod/.test(navigator.userAgent);

const useStyles = makeStyles((theme) => ({
    root: {
        color: '#ffb615',

        '& h3, & h4, & h5, & h6, & a': {
            color: '#ffb615'
        },
        '& h4': {
            color: '#ffb615'
        },
        '& svg': {
            fill: '#ffb615'
        }
    },
    formControl: {
        color: '#ffb615',
        margin: theme.spacing(1),
        minWidth: 120,
    },
    selectEmpty: {
        marginTop: theme.spacing(2),
    },
}))
export const VRLanding = () => {

    const classes = useStyles();

    const [error, setError] = useState(null);
    const [channel, setChannel] = useState({
        streams: [
            {
                url: '/vr-streams/5897.high/playlist.m3u8',
                quality: 'high'
            }, {
                url: '/vr-streams/5897.low/playlist.m3u8',
                quality: 'low'
            },
        ]
    });
    const [videoJsOptions, setVideoJsOptions] = useState({
        autoplay: true,
        controls: true,
        liveui: true
    });


    useEffect(() => {
        if (!channel) return;
        setVideoJsOptions({
            ...videoJsOptions,
            sources: channel.streams.map(source => ({
                src: source.url,
                type: iOS ? 'application/vnd.apple.mpegurl' : 'application/x-mpegurl',
                label: source.quality === 'low' ? '480p' : '720p'
            }))
        });

    }, [channel])

    useEffect(() => {
        document.querySelector('body').style.paddingLeft = 0;

        return () => {
            document.querySelector('body').style.paddingLeft = '56px';
            window.screen.orientation.unlock();
        }
    }, [])

    if (!channel || !videoJsOptions.sources) {
        return (
            <section className={classes.root}>
                <Grid container justify="space-around" direction="row" spacing={4}>
                    <Grid item xs={11}></Grid>
                    <Grid item xs={1}> <NavLink to={"/hologram-icons/vr"}>VR</NavLink> | <NavLink
                        to={"/hologram-icons/"}>Promo</NavLink></Grid>

                    <Grid item xs={12} sm={11} md={10} lg={9} xl={8}>
                        Loading... keep calm
                    </Grid>
                </Grid>
            </section>
        )
    }

    if (error) {
        return (
            <section className={classes.root}>
                <Grid container justify="space-around" direction="row" spacing={4}>
                    <Grid item xs={11}></Grid>
                    <Grid item xs={1}> <NavLink to={"/hologram-icons/vr"}>VR</NavLink> | <NavLink
                        to={"/hologram-icons/"}>Promo</NavLink></Grid>

                    <Grid item xs={12} sm={11} md={10} lg={9} xl={8}>
                        <pre>
                        {JSON.stringify(error, null, 4)}
                        </pre>
                    </Grid>
                </Grid>
            </section>
        )
    }

    return (<section className={classes.root}>
        <VideoPlayer {...videoJsOptions} vr debug forceCardboard projection="360" forceLandscape/>
    </section>);
}
